import type { FC } from "react"
import React from "react"

import styled from "styled-components"

import { ReactComponent as RevisionIcon } from "@svg/new-design-revision.svg"

const AddNewVersion = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  padding: var(--space-xs) 0;
  svg {
    width: 35%;
    height: 120px;
  }
  h3 {
    text-transform: capitalize;
    font-weight: 600;
    color: var(--blue-dark-font);
    font-size: var(--step--1);
    margin-top: var(--space-m);
    margin-bottom: var(--space-2xs);
  }
  p {
    font-size: var(--step--1);
    color: var(--grey-dark);
    max-width: 50%;
    text-align: center;
    line-height: 1.25;
  }
`

export const Placeholder: FC = () => {
  return (
    <AddNewVersion>
      <RevisionIcon />
      <h3>Add new version</h3>
      <p>To create a new version, click the plus button at the top.</p>
    </AddNewVersion>
  )
}
